import { api, authHeader } from "../configs/axiosConfigs";

const gridBase = "/SLN/DistributionCompany/DistributionGrid";

const unwrap = (response) => response?.data ?? response;

const get = async (action, companyId) =>
  unwrap(
    await api.request({
      url: `${gridBase}/${action}`,
      method: "GET",
      params: { companyId },
      headers: authHeader(),
    })
  );

const post = async (action, body) =>
  unwrap(
    await api.request({
      url: `${gridBase}/${action}`,
      method: "POST",
      data: body,
      headers: authHeader(),
    })
  );

const DistributionGridApi = {
  getLookups: (companyId) => get("GetLookups", companyId),

  listSubstations: (companyId) => get("ListSubstations", companyId),
  saveSubstation: (body) => post("SaveSubstation", body),
  deleteSubstation: (body) => post("DeleteSubstation", body),

  listFeeders: (companyId) => get("ListFeeders", companyId),
  saveFeeder: (body) => post("SaveFeeder", body),
  deleteFeeder: (body) => post("DeleteFeeder", body),

  listLVTrans: (companyId) => get("ListLVTrans", companyId),
  saveLVTrans: (body) => post("SaveLVTrans", body),
  deleteLVTrans: (body) => post("DeleteLVTrans", body),
};

export default DistributionGridApi;
